import ToolSidebar from "../utils/ToolSideBar";
import AvailabilitySettingsCard from "../partners/settings/AvailabilitySettingsCard";
import "../../css/partner/Meetings.css";

export default function MeetingAvailabilityPage({ partner }) {
  return (
    <div className="staff-shell">
      <ToolSidebar active="settings" isPartner={partner} />
      <main className="staff-page meetings-page availability-settings-page">
        <header className="meeting-hero compact-hero">
          <div>
            <span>Settings</span>
            <h1>Availability</h1>
            <p>Control when other portal users can request meetings with you.</p>
          </div>
        </header>
        <AvailabilitySettingsCard />
      </main>
    </div>
  );
}
